import controller from './insert-filter-modal-trigger-controller';

const InsertFilterModalTriggerDirective: angular.IDirectiveFactory = function InsertFilterModalTriggerDirective() {
  return {
    controller,
    controllerAs: 'ctrl',
    restrict: 'A',
    scope: {
      onInsert: '&?',
    },
  };
};

export { InsertFilterModalTriggerDirective };
